import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\AddWikiSharedDocToDocumentsController::__invoke
* @see app/Http/Controllers/Document/AddWikiSharedDocToDocumentsController.php
* @route '/api/add-wiki-shared-document'
*/
const AddWikiSharedDocToDocumentsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiSharedDocToDocumentsController.url(options),
    method: 'post',
})

AddWikiSharedDocToDocumentsController.definition = {
    methods: ["post"],
    url: '/api/add-wiki-shared-document',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\AddWikiSharedDocToDocumentsController::__invoke
* @see app/Http/Controllers/Document/AddWikiSharedDocToDocumentsController.php
* @route '/api/add-wiki-shared-document'
*/
AddWikiSharedDocToDocumentsController.url = (options?: RouteQueryOptions) => {
    return AddWikiSharedDocToDocumentsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\AddWikiSharedDocToDocumentsController::__invoke
* @see app/Http/Controllers/Document/AddWikiSharedDocToDocumentsController.php
* @route '/api/add-wiki-shared-document'
*/
AddWikiSharedDocToDocumentsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiSharedDocToDocumentsController.url(options),
    method: 'post',
})

export default AddWikiSharedDocToDocumentsController